import { useStore } from 'effector-react'

import {
  $totalCountOfDividendAccruedList,
  getDividendAccruedList,
  dividendAccruedListMounted,
  $dividendAccruedList,
} from './model'
import { DividendAccruedRequest } from './types'

export const useDividendAccruedList = () => {
  const dividendAccruedList = useStore($dividendAccruedList)
  const loading = useStore(getDividendAccruedList.pending)
  const totalCountOfDividendAccruedList = useStore(
    $totalCountOfDividendAccruedList,
  )

  const onChangeDividendAccruedList = ({
    limit,
    page,
    orderBy,
    orderDirection,
  }: DividendAccruedRequest) => {
    dividendAccruedListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
    })
  }

  return {
    dividendAccruedList,
    totalCountOfDividendAccruedList,
    loading,
    onChangeDividendAccruedList,
  }
}
